import { all, takeLatest } from "redux-saga/effects";
import * as general from "./general";

export function* watchUsers() {
  yield all([takeLatest("IDENTITY_GET", general.identityWatcher)]);
}
